<template>
  <Icon :component="DetailSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import DetailSvg from './svg/DetailSvg.vue';

export default defineComponent({
  name: 'DetailIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      DetailSvg: markRaw(DetailSvg)
    };
  }
});
</script>
